function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Marketing-collateral-genrator",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "4.0a-\\u2013-Brochure-Layout",
  transform: "translate(-113.000000, -441.000000)"
}, React.createElement("g", {
  id: "update-icon",
  transform: "translate(115.000000, 443.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  stroke: "#FFFFFF",
  strokeWidth: 1.5,
  fill: "#CBE8EE",
  x: -0.75,
  y: -0.75,
  width: 47.5,
  height: 16.5
}), React.createElement("text", {
  id: "Update",
  opacity: 0.70031157,
  fontFamily: "MavenPro-Bold, Maven Pro",
  fontSize: 10,
  fontWeight: "bold",
  fill: "#363636"
}, React.createElement("tspan", {
  x: 5.585,
  y: 11
}, "Update")))));

const SvgUpdateIcon = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "50px",
    height: "19px",
    viewBox: "0 0 50 19",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgUpdateIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/update-icon.055d49b0.svg";
export { ForwardRef as ReactComponent };